import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import FlagItem from "./FlagItem";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class ExperienceItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const {
      gnObject: { experience, ...gnObject }
    } = this.props;
    return (
      <Col xs="12" md="6">
        <Card>
          <CardHeader>Experience</CardHeader>
          <CardBody>
            <h5>User: {experience.author.name}</h5>
            <h6>User ID: {experience.author.id}</h6>
            <hr />
            {experience.image && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${experience.image.cloudinaryId}`}
              />
            )}
            <p>{experience.text}</p>
            {gnObject.gnObjectAttached && (
              <FlagItem
                isChild
                type={gnObject.gnObjectAttached.type}
                gnObject={gnObject.gnObjectAttached.gnObject}
              />
            )}
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default ExperienceItem;



// WEBPACK FOOTER //
// ./src/views/Components/ExperienceItem.js